import { useState, useRef, useEffect } from "react";
import { supabase } from "../supabase/client";
import { useNavigate } from "react-router-dom";
import { useUser } from "../context/Usercontext";
import LeftBox from "../components/LeftBox";
import TweetsArea from "../components/TweetsArea";

let Profile = function () {
  let {
    user,
    setUser,
    userObject,
    setUserObject,
    likedPosts,
    lastLikeDeleted,
    getPosts,
  } = useUser();

  const navigate = useNavigate();

  useEffect(() => {
    let gettingSession = async function () {
      const { data, error } = await supabase.auth.getSession();

      //
      if (!data.session) {
        navigate("/login");
      } else {
        setUser(data.session.user.user_metadata);
        setUserObject(data.session.user);
      }

      console.log(data.session);
    };

    gettingSession();
  }, [navigate]);

  let handleTesting = () => {
    console.log(user);
    console.log(userObject);
    console.log(likedPosts);
    console.log(lastLikeDeleted);
    getPosts();
  };

  let singOut = async function (params) {
    const { error } = await supabase.auth.signOut();

    navigate("/login");
    setUser(null);
  };

  ///

  if (user) {
    return (
      <div className="main-profile-page">
        <LeftBox handleTesting={handleTesting} singOut={singOut} />
        <div className="main-profile-box-middle">
          <TweetsArea navigate={navigate} />
        </div>
        <div className="main-profile-box-right">Ya</div>
      </div>
    );
  }
};

export default Profile;

/**
 *
 */
